// extracted by mini-css-extract-plugin
export default {"likesCount":"k_n5ZeYblHOoN5NP9L_V","likeIcon":"h546wbYquPQJ77LizKLe"};